import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class ElementFocusService {
  private readonly router: Router = inject(Router);

  public focusElement(isViewReady: boolean): void {
    if (this.router.url.includes('#') && isViewReady) {
      setTimeout(() => {
        const scrollId: string = this.router.url.split('#')[1];
        const element = document.querySelector(
          `[scroll-mark="${scrollId}"]`
        ) as HTMLElement;
        if (element) {
          const headerOffset = 125;
          const elementPosition: number = element.getBoundingClientRect().top;
          const offsetPosition: number =
            elementPosition + window.pageYOffset - headerOffset;
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
          this.highlightElement(element);
        }
      }, 500);
    }
  }
  public highlightElement(element: HTMLElement): void {
    element.style.animationName = 'focus-element';
    element.style.animationDuration = '4s';
    element.style.borderRadius = '0.5rem';
    setTimeout(() => (element.style.animationName = ''), 4000);
  }
}
